import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of, throwError } from "rxjs";
import Swal, { SweetAlertOptions } from "sweetalert2";

@Injectable({
  providedIn: "root",
})
export class LoadingService {
  private active_loadings_sub: BehaviorSubject<string[]>;
  public active_loadings: Observable<string[]>;
  private debounceTimeout: any = null;
  private isLoaderVisible = false;

  constructor() {
    this.active_loadings_sub = new BehaviorSubject<string[]>([]);
    this.active_loadings = this.active_loadings_sub.asObservable();
    this.check();
  }

  push_a_loading(action_name: string) {
    this.active_loadings_sub.value.push(action_name);
    this.debouncedCheck();
  }

  remove_a_loading(action_name: string) {
    this.active_loadings_sub.next(
      this.active_loadings_sub.value.filter((a) => {
        return a != action_name;
      })
    );
    this.debouncedCheck();
  }

  remove_all() {
    this.active_loadings_sub.next([]);
    this.debouncedCheck();
  }

  private debouncedCheck() {
    // Cancella il timeout precedente per evitare flickering
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }

    // Imposta un nuovo timeout per aggiornare il loader
    this.debounceTimeout = setTimeout(() => {
      this.check();
    }, 100); // 100ms debounce - abbastanza per gruppare richieste multiple
  }

  private check() {
    const activeCount = this.active_loadings_sub.value.length;

    if (activeCount > 0) {
      if (!this.isLoaderVisible) {
        this.isLoaderVisible = true;

        Swal.fire({
          title: "Loading...",
          showCancelButton: false,
          showConfirmButton: false,
          backdrop: `rgba(0,0,123,0.4)`,
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        } as SweetAlertOptions);
      } else {
        // Aggiorna solo il testo se il loader è già visibile
        // const existingLoader = document.querySelector(".swal2-html-container");
        // if (existingLoader) {
        //   existingLoader.textContent = activeCount + text;
        // }
      }
    } else {
      if (this.isLoaderVisible) {
        this.isLoaderVisible = false;
        Swal.close();
      }
    }
  }
}
